var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEditDateFinder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icEditDateFinder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DateFinder",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add-dates",
    transform: "translate(-328.000000, -599.000000)",
    fill: "#333333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.306562,602.083016 L340.089383,604.87944 L333.045294,611.958026 L330.26405,609.161602 L337.306562,602.083016 Z M342.201007,601.408582 L340.959975,600.161473 C340.48036,599.679509 339.701563,599.679509 339.220317,600.161473 L338.031534,601.356079 L340.814355,604.152529 L342.201007,602.759087 C342.572998,602.385248 342.572998,601.782395 342.201007,601.408582 Z M328.807744,613.092201 C328.7571,613.32124 328.962883,613.526471 329.190831,613.470771 L332.291819,612.715217 L329.510575,609.918793 L328.807744,613.092201 Z",
    id: "icEditDateFinder"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEditDateFinder);
export default __webpack_public_path__ + "static/media/icEditDateFinder.838c8635c762a8f9f44b0cad1005f7e1.svg";
export { ForwardRef as ReactComponent };